<template>
    <div class="remaining-time">
        <span v-if="!expanded">{{ remainingTime }}</span>
        <template v-if="expanded">
            <div v-if="days" class="time-counter">
                <span>{{ days }}</span>
                <span class="label">дней</span>
            </div>
            <div v-if="days" class="separator">:</div>
            <div class="time-counter">
                <span>{{ hours }}</span>
                <span class="label">часов</span>
            </div>
            <div class="separator">:</div>
            <div class="time-counter">
                <span>{{ minutes }}</span>
                <span class="label">минут</span>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "RemainingTime",
        props: {
            timestamp: {
                required: true
            },
            expanded: {
                required: false,
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                remainingTime: '',
                days: null,
                hours: null,
                minutes: null,
            }
        },
        mounted () {
            let _this = this;

            if (this.expanded) {
                _this.updateRemainingTime();

                setInterval(function () {
                    _this.updateRemainingTime();
                }, 60000);
            } else {
                _this.remainingTime = _this.getTimeLabel(_this.getRemainingTime(_this.timestamp));

                setInterval(function () {
                    _this.remainingTime = _this.getTimeLabel(_this.getRemainingTime(_this.timestamp));
                }, 60000);
            }
        },
        methods: {
            updateRemainingTime () {
                let now = new Date();
                let date = new Date(this.timestamp * 1000);

                let seconds = Math.floor((date - now)/1000);
                let minutes = Math.floor(seconds/60);
                let hours = Math.floor(minutes/60);
                let days = Math.floor(hours/24);

                hours = (hours-(days*24));
                minutes = minutes-(days*24*60)-hours*60;

                this.days = days;
                this.hours = hours.toString().length === 1 ? '0' + hours : hours;
                this.minutes = minutes.toString().length === 1 ? '0' + minutes : minutes;
            },

            getRemainingTime (endDate) {
                let now = new Date();
                let date = new Date(endDate * 1000);

                let seconds = Math.floor((date - now)/1000);
                let minutes = Math.floor(seconds/60);
                let hours = Math.floor(minutes/60);
                let days = Math.floor(hours/24);

                hours = (hours-(days*24));
                minutes = minutes-(days*24*60)-hours*60;

                return {
                    days: days,
                    hours: hours,
                    minutes: minutes
                }
            },
            getTimeLabel (date) {

                let string = date.days > 0 ? `${date.days} д ` : '';
                string += date.hours > 0 ? `${date.hours} ч ` : '';
                string += date.minutes > 0 ? `${date.minutes} м ` : '';

                return string;
            }
        }
    }
</script>

